import { useState, useEffect } from "react"

const isMobileDevice = () => {
	if (typeof window === "undefined") return false
	if (typeof navigator === "undefined") return false
	return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
}

const UseWindowSize = () => {
	const [windowSize, setWindowSize] = useState({
		width: null,
		height: null,
		isMobile: false,
		isTablet: false,
		isDesktop: false,
		isLandscape: false,
	})

	useEffect(() => {
		if (typeof window !== "undefined") {
			const handleResize = () => {
				setWindowSize({
					width: window.innerWidth,
					height: window.innerHeight,
					isMobile: window.innerWidth < 768,
					isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
					isDesktop: window.innerWidth >= 1024,
					isLandscape: !isMobileDevice() ||  (window.innerWidth > window.innerHeight),
				})
			}

			// Initialize window size on first load
			handleResize()

			window.addEventListener("resize", handleResize)

			// Cleanup on component unmount
			return () => {
				window.removeEventListener("resize", handleResize)
			}
		}
	}, []) // Remove `window` dependency to avoid SSR issues

	return windowSize
}

export default UseWindowSize
